import { createFileRoute, redirect } from "@tanstack/react-router";
import { resolveAdminRedirect } from "@/lib/adminRedirects";

// URL retirada: se conserva para siempre y solo redirige (mapa en adminRedirects).
export const Route = createFileRoute("/admin/facturas")({
  beforeLoad: ({ location }) => {
    throw redirect({ href: resolveAdminRedirect(location.pathname, location.searchStr ?? "") ?? "/admin", replace: true });
  },
});
